import React from "react";

// components
import SectionContainer from "core/SectionContainer";
import Collections from "core/Collections";
import LoadingSpinner from "core/LoadingSpinner";
import Button from "core/Button";
import AvatarPlaceholderImg from "core/AvatarPlaceholderImg";

// helpers
import useLoadMore from "frontend/hooks/useLoadMore";
import { getArrayOfCollectionIcons } from "icons/helpers";
import { convertPxToRem } from "frontend/components/helpers";

// temp query:
import { GET_ICON_COLLECTIONS } from "./queries";

// styles
import { Container, StyledA, InfoHeading, ButtonContainer } from "./styles";

const CreatorCollectionSearch = () => {
    const { items, loading, loadMore, totalCount } = useLoadMore({
        query: GET_ICON_COLLECTIONS,
        queryVariables: { query: "icons" },
        pathToListKey: "collectionSearch.items",
        pathToTotalCountKey: "collectionSearch.totalCount",
        limit: 4
    });

    const showLoadMore = items.length < totalCount;

    if (loading) return <LoadingSpinner />;

    // helper to reformat data to match Collections component:
    const collections = items.map(collection => {
        return {
            title: collection.name,
            url: `/${collection.creator.username}/collection/${collection.slug}/`,
            imageSrc: getArrayOfCollectionIcons({
                icons: collection.icons
            }),
            type: "secondary",
            usePlaceholder: true,
            subtitle: collection.icons.totalCount + " icons"
        };
    });

    return (
        <SectionContainer topSpacing="2xl" bottomSpacing="3xl">
            <Container>
                <AvatarPlaceholderImg />
                <InfoHeading>
                    All Collections by <StyledA>Jolie Collins</StyledA>
                </InfoHeading>
            </Container>
            <Collections collections={collections} />
            {showLoadMore && (
                <ButtonContainer>
                    <Button
                        width={convertPxToRem({ px: 160 })}
                        onClick={e => {
                            e.preventDefault();
                            loadMore();
                        }}
                    >
                        Load More
                    </Button>
                </ButtonContainer>
            )}
        </SectionContainer>
    );
};

export default CreatorCollectionSearch;
